import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import findIndex from 'lodash/findIndex';

import PropTypes from 'prop-types';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import CaretLeft from '@zg-rentals/multibrand-ui/lib/icons/CaretLeft';
import CaretRight from '@zg-rentals/multibrand-ui/lib/icons/CaretRight';

// TODO: update mui Row, Col to use zrs-comet
import { Container } from '@zillow/zrs-comet';

// rmw context
import { RMWContext } from 'app/shared/providers/RMWContext';

import { Link as v4Link } from 'react-router-dom';

// Actions
import LeadActions from 'app/shared/actions/LeadActions';

// containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

import analyticsUtils from 'app/client/utils/analyticsUtils';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import LeadResume from 'app/shared/components/lead/LeadResume';
import LeadRequest from 'app/shared/components/lead/LeadRequest';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';
import Breadcrumb from 'app/shared/components/Breadcrumb';

import userUtils from 'app/shared/utils/userUtils';

// data models
import LeadsForListing from 'app/shared/model/LeadsForListing';

// constants
import Constants from 'app/shared/constants';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

// Selectors
import {
    AppSelectors, LeadSelectors, RoutingSelectors, UserSelectors,
} from 'app/shared/selectors';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import pathsManifest from 'app/shared/pathsManifest';

import './style.scss';

const propTypes = {
    lead: PropTypes.object.isRequired,
};

class LeadPage extends React.Component {
    static contextType = RMWContext;

    constructor(props) {
        super(props);

        this.state = this.getInitialState();

        this.fetchLead = this.fetchLead.bind(this);
        this.updateRoute = this.updateRoute.bind(this);
        this.findCurrentLeadIndex = this.findCurrentLeadIndex.bind(this);
        this.setWhereUserIsFrom = this.setWhereUserIsFrom.bind(this);
        this.fetchLeadsForListing = this.fetchLeadsForListing.bind(this);
        this.handleNextLeadClick = this.handleNextLeadClick.bind(this);
        this.handlePrevLeadClick = this.handlePrevLeadClick.bind(this);
        this.isFromContactsPage = this.isFromContactsPage.bind(this);
        this.renderLoadComplete = this.renderLoadComplete.bind(this);
        this.renderBreadcrumb = this.renderBreadcrumb.bind(this);
        this.renderFooterActions = this.renderFooterActions.bind(this);
        this.handleApplyButtonClick = this.handleApplyButtonClick.bind(this);
    }

    componentDidMount() {
        const { match } = this.props;
        const { leadId } = match.params;

        this.fetchLead(leadId);

        // If the store has the accurate prevPath when mounting the component
        // TODO: Should use subroutes instead to avoid async handling
        this.setWhereUserIsFrom(this.props.prevPath);
    }

    componentWillReceiveProps(nextProps) {
        // check leadId
        if (nextProps.match.params.leadId !== this.props.match.params.leadId) {
            this.fetchLead(nextProps.match.params.leadId);
        }

        // If the store updated the prevPath with the accurate prevPath after mount
        // TODO: Should use subroutes instead to avoid async handling
        if (nextProps.prevPath !== this.props.prevPath) {
            this.setWhereUserIsFrom(nextProps.prevPath);
        }
    }

    // if user comes to the lead page from either:
    // 1) rental-manager/contacts, (ContactsPage)
    // 2) rental-manager/property_id/leads (GlobalLeadsPage)
    // 3) rental-manager/property_id/contacts (PropertyDetailsContactsPage)
    // 4) null (End up to the page directly by entering the url)
    // Only save if they came from Contacts page or GlobalLeads page. Assumed they come from 3 or 4 otherwise.
    setWhereUserIsFrom(prevPath) {
        const isFromContactsPage = this.isFromContactsPage(prevPath);
        const isFromGlobalLeadsPage = this.isFromGlobalLeadsPage(prevPath);

        if (isFromContactsPage || isFromGlobalLeadsPage) {
            this.setState({
                isFromContactsPage,
                isFromGlobalLeadsPage,
            });
        }
    }

    getInitialState() {
        return {
            isLoading: true,
            isFound: false,
            isFromContactsPage: false, // ended up on that page from rental-manager/contacts
            isFromGlobalLeadsPage: false,
        };
    }

    fetchLead(leadId) {
        if (!leadId) {
            return console.warn('ERROR: leadId is required');
        }

        const { dispatch, roles } = this.props;

        this.setState({ isLoading: true });

        dispatch(LeadActions.getLead({ leadId, includeListingDetails: true }))
            .then(() => {
                this.setState({
                    isLoading: false,
                    isFound: true,
                });
            })

            // update read status for inquiry
            .then(() => {
                const isPostingPathAdmin = userUtils.isPostingPathAdmin(roles);

                if (!isPostingPathAdmin) {
                    dispatch(LeadActions.updateLeadStatus({ leadId, read: true }));
                }
            })
            .catch((err) => {
                global.TEMPORARY_global_logger.error(err, 'ERROR when loading inquiry: ');

                this.setState({
                    isLoading: false,
                    isFound: false,
                });
            });

        return false;
    }

    updateRoute(inquiries, index) {
        const paths = pathsManifest.getAllPaths();
        const leadId = inquiries[index].id;
        const baseLeadUrl = paths.leadPage;
        const url = `${baseLeadUrl}/${leadId}`;

        window.router.transitionTo(url);
    }

    fetchLeadsForListing(params) {
        const { dispatch } = this.props;

        return dispatch(LeadActions.getLeadsForListing(params))
            .then((result) => {
                const { payload } = result;

                if (payload.success === false) {
                    if (payload.error.message.toLowerCase().indexOf('access denied') > -1) {
                        console.error('ERROR: Access denied');
                    }
                } else {
                    return LeadsForListing(payload.leadsForListingModel);
                }

                return false;
            });
    }

    handleNextLeadClick(event) {
        event.preventDefault();
        const { leadsForListing, lead } = this.props;
        const { pager, inquiries: leadList } = leadsForListing;
        const currentLeadIndex = this.findCurrentLeadIndex();

        const { listingId } = lead.listing;
        const { limit, nextPage } = pager;
        let targetLeadIndex = currentLeadIndex + 1;

        // check if index needs to paginate
        if (targetLeadIndex > leadList.length - 1) {
            // paginate
            const targetNextPage = nextPage !== 0 ? nextPage : 1;
            const start = (targetNextPage - 1) * limit;

            const params = {
                listingId,
                start,
                limit,
            };

            this.fetchLeadsForListing(params).then((response) => {
                const { inquiries: leadList } = response;
                targetLeadIndex = 0;

                if (leadList.length > 0) {
                    this.updateRoute(leadList, targetLeadIndex);
                }
            });
        } else {
            // no paginate
            this.updateRoute(leadList, targetLeadIndex);
        }
    }

    handlePrevLeadClick(event) {
        event.preventDefault();
        const { leadsForListing, lead } = this.props;
        const { pager, inquiries: leadList } = leadsForListing;
        const currentLeadIndex = this.findCurrentLeadIndex();

        const { listingId } = lead.listing;
        const { backPage, limit, numPages } = pager;
        let targetLeadIndex = currentLeadIndex - 1;

        // check if index needs to paginate
        if (targetLeadIndex < 0) {
            // paginate
            const targetBackPage = backPage !== 0 ? backPage : numPages;
            const start = (targetBackPage - 1) * limit;

            const params = {
                listingId,
                start,
                limit,
            };

            this.fetchLeadsForListing(params).then((response) => {
                const { inquiries: leadList } = response;
                targetLeadIndex = leadList.length - 1;
                if (leadList.length > 0) {
                    this.updateRoute(leadList, targetLeadIndex);
                }
            });
        } else {
            // no paginate
            this.updateRoute(leadList, targetLeadIndex);
        }
    }

    handleApplyButtonClick() {
        const {
            dispatch,
        } = this.props;

        // GA tracking
        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.APPLICATIONS_INVITE_TO_APPLY));
    }

    isLeadEligibleForApply() {
        const { brand, lead } = this.props;

        if (isEmpty(lead.listing.listingDetails)) {
            return false;
        }

        const isZillow = brand === Constants.UNFORMATTED_BRAND_NAMES.zillow;

        return isZillow &&
            !lead.inquiry.isPhoneLead &&
            !lead.listing.listingDetails.isMultifamily;
    }

    isFromContactsPage(path) {
        const paths = pathsManifest.getAllPaths();
        return path && path.indexOf(paths.contactsPage) > -1;
    }

    isFromGlobalLeadsPage(path) {
        const paths = pathsManifest.getAllPaths();
        return path && path.indexOf(paths.globalLeadsPage) > -1;
    }

    findCurrentLeadIndex() {
        const { id } = this.props.lead.inquiry;
        const leadList = this.props.leadsForListing.inquiries;

        const foundIndex = findIndex(leadList, obj => obj.id === id);

        return foundIndex || 0;
    }

    hideNextLead(currentLeadIndex, pager) {
        const {
            currentPage, numPages, total, limit,
        } = pager;
        const isLastPage = currentPage === numPages;
        const isLastLeadOfPage = (currentLeadIndex + 1) === (total % limit);
        return isLastPage && isLastLeadOfPage;
    }

    hidePrevLead(currentLeadIndex, pager) {
        const isFirstPage = pager.start === 0;
        const isFirstLeadOfPage = currentLeadIndex === 0;
        return isFirstPage && isFirstLeadOfPage;
    }

    renderBreadcrumb() {
        const paths = pathsManifest.getAllPaths();
        const { isFromContactsPage, isFromGlobalLeadsPage } = this.state;
        const { street, listingId } = this.props.lead.listing;
        let breadCrumbTitle = '';
        let url = '';
        if (isFromContactsPage) {
            breadCrumbTitle = 'Back to contacts';
            url = paths.contactsPage;
        } else if (isFromGlobalLeadsPage) {
            breadCrumbTitle = 'Back to All Leads';
            url = `${paths.base}/properties/${listingId}/${paths.globalLeadsPage}`;
        } else {
            breadCrumbTitle = `Contacts for ${street}`;
            url = `${paths.base}/properties/${listingId}/${paths.propertyDetailsContacts}`;
        }

        return <Breadcrumb title={breadCrumbTitle} redirectTo={url} />;
    }

    renderFooterActions() {
        const { inquiries: leadList, pager } = this.props.leadsForListing;

        const titlePrev = 'Previous lead';
        const titleNext = 'Next lead';
        const currentLeadIndex = this.findCurrentLeadIndex();
        const { isFromContactsPage } = this.state;

        // Allow to navigate through inquiries only when coming from rental-manager/property_id/contacts
        // or by entering the url directly
        const displayActions = !isFromContactsPage && leadList.length > 0;
        return (
            <div>
                {displayActions &&
                    (
                        <Row noPadding={true}>
                            <Col>
                                <div className="LeadPage-FooterActions">
                                    {!this.hidePrevLead(currentLeadIndex, pager) && (
                                        <div
                                            className="LeadPage-FooterActions-PrevLead"
                                            onClick={this.handlePrevLeadClick}
                                        >
                                            <Link reactRouterLink={v4Link} to="/">
                                                <CaretLeft size={14} />
                                                <Text type="body">{titlePrev}</Text>
                                            </Link>
                                        </div>
                                    )}

                                    {!this.hideNextLead(currentLeadIndex, pager) && (
                                        <div
                                            className="LeadPage-FooterActions-NextLead"
                                            onClick={this.handleNextLeadClick}
                                        >
                                            <Link reactRouterLink={v4Link} to="/">
                                                <Text type="body">{titleNext}</Text>
                                                <CaretRight size={14} />
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}
            </div>
        );
    }

    isEmptyLeadResume(leadData) {
        if (!leadData) {
            return true;
        }

        const {
            credit,
            employer,
            isSmoker,
            income,
            jobTitle,
            moveInTimeframe,
            pets,
            numOccupants,
        } = leadData.attributes;

        const isEmptyResponse =
            isEmpty(leadData.attributes) ||
            (isNil(credit) &&
                isNil(employer) &&
                isNil(isSmoker) &&
                isNil(income) &&
                isNil(jobTitle) &&
                isNil(moveInTimeframe) &&
                (pets && pets.length === 0) &&
                isNil(numOccupants));

        return isEmptyResponse;
    }

    renderInviteToApply() {
        const { leadId } = this.props.match.params;
        const paths = pathsManifest.getAllPaths();
        const { listingId } = this.props.lead.listing;
        const basePropertyUrl = paths.propertiesPage;
        const applicationsPage = paths.propertyDetailsApplications;
        const applicationsInviteUrl = `${basePropertyUrl}/${listingId}/${applicationsPage}?leadId=${leadId}`;

        if (!this.isLeadEligibleForApply()) {
            return null;
        }

        return (
            <React.Fragment>
                <Row className="LeadPage-Invitation">
                    <Col md={5}>
                        <Link
                            data-test="apply-button"
                            className="LeadPage-Button stacked-md Button Button-primary Button-full"
                            href={applicationsInviteUrl}
                            onClick={this.handleApplyButtonClick}
                        >
                                Invite to apply
                        </Link>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderLoadComplete(leadData, listingData) {
        const { isScreenMobile } = this.props;

        if (this.state.isFound) {
            return (
                <Container className="LeadPage-Container" fluidMobile={true}>
                    {this.renderBreadcrumb()}

                    <Row className="LeadPage-Row" noPadding={true}>
                        <Col>
                            <LeadRequest
                                isScreenMobile={isScreenMobile}
                                leadData={leadData}
                                listingData={listingData}
                            >
                                {this.renderInviteToApply()}
                            </LeadRequest>
                        </Col>
                    </Row>

                    {!this.isEmptyLeadResume(leadData) && (
                        <Row
                            className={cx([
                                'LeadPage-RenterResume',
                                'LeadPage-Row',
                            ])}
                            noPadding={true}
                        >
                            <Col>
                                <LeadResume leadData={leadData} />
                            </Col>
                        </Row>
                    )}
                    <StyledContainer
                        className="LeadPage-padding"
                        backgroundColor="lightestGrey"
                    >
                        {this.renderFooterActions()}
                    </StyledContainer>
                </Container>
            );
        }
        return (
            <Container>
                <Row>
                    <Col>
                        <Text type="h4">Inquiry not found</Text>
                    </Col>
                </Row>
            </Container>
        );
    }

    render() {
        const { lead } = this.props;
        const titleContent = lead.listing ? `Inquiry for ${lead.listing.name}` : 'Inquiry';

        return (
            <AuthCheckWrapper requireStrongAuthentication={false}>
                <div className="LeadPage">
                    <HeadWrapper title={titleContent} />
                    {this.state.isLoading ?
                        <SpinnerContainer /> :
                        this.renderLoadComplete(lead.inquiry, lead.listing)}
                </div>
            </AuthCheckWrapper>
        );
    }
}

const mapStateToProps = state => ({
    isScreenMobile: AppSelectors.makeIsScreenMobile(state),
    leadsForListing: LeadSelectors.makeLeadsForListing(state),
    lead: LeadSelectors.makeLead(state),
    user: UserSelectors.makeUser(state),
    location: RoutingSelectors.makeLocation(state),
    prevPath: AppSelectors.makePrevPath(state),
    roles: UserSelectors.makeRoles(state),
    brand: AppSelectors.makeBrand(state),
});

LeadPage.propTypes = propTypes;

export { LeadPage };
export default connect(mapStateToProps)(LeadPage);
